exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group-flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n.form-group-flex label {\n  display: block;\n  width: 100%;\n}\n.form-control-flex {\n  flex: 1;\n  margin-right: 5px;\n}", ""]);

// exports
